import AuthApi from './auth-api';

export default AuthApi;
